<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
	<label for="file">Choose .csv file to upload</label>
	<input
		#fileInput
		(change)="handleFileInput($event.target.files)"
		accept=".csv"
		id="file"
		type="file"
	/>
	<a
		(click)="clearFile()"
		*ngIf="fileData && fileData.length > 0"
		style="text-decoration: underline !important; cursor: pointer; color: blue"
		>Clear</a
	>
</div>
